// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concept-videos-topic:hover {
  background-color: #ebebff !important;
  color: #1d2026 !important;
}

.reviewButtonsStyles {
  padding: 0px 24px 0px 24px;
  gap: 12px;
  border-radius: 5px 0px 0px 0px;
  background-color: white;
  font-size: 16px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.008em;
  text-align: left;
  color: #564ffd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scrollbarWidth::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.scrollbarWidth::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px lightgray;
  border-radius: 10px;
}

/* Handle */
.scrollbarWidth::-webkit-scrollbar-thumb {
  background: lightgray;
  border-radius: 10px;
}

.name-time-row-watch:hover {
  background-color: #ebebff !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentPages/ConceptVideos/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,yBAAA;AACF;;AAEA;EACE,0BAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA,UAAA;AACA;EACE,mCAAA;EACA,mBAAA;AACF;;AAEA,WAAA;AACA;EACE,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".concept-videos-topic:hover {\n  background-color: #ebebff !important;\n  color: #1d2026 !important;\n}\n\n.reviewButtonsStyles {\n  padding: 0px 24px 0px 24px;\n  gap: 12px;\n  border-radius: 5px 0px 0px 0px;\n  background-color: white;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.008em;\n  text-align: left;\n  color: #564ffd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scrollbarWidth::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n.scrollbarWidth::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px lightgray;\n  border-radius: 10px;\n}\n\n/* Handle */\n.scrollbarWidth::-webkit-scrollbar-thumb {\n  background: lightgray;\n  border-radius: 10px;\n}\n\n.name-time-row-watch:hover {\n  background-color: #ebebff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
